const FONT_WEIGHT_MAP = {
  normal: 400,
  medium: 500,
  semibold: 600,
  bold: 700
};
const getFontWeightValue = (weight) => FONT_WEIGHT_MAP[weight] ?? 400;
function buildPromptInputStyles(p) {
  const mobileRules = `
      .concierge-prompt-input {
        --icon-size: ${p.mobileIconSize}px;
        --submit-button-size: ${p.mobileSubmitButtonSize}px;
        --font-size-small: ${p.mobileFontSize}px;
        --font-size-base: ${p.mobileFontSize}px;
      }
      .concierge-prompt-input textarea,
      .concierge-prompt-input textarea[data-slot="input-group-control"] {
        font-size: ${p.mobileFontSize}px !important;
      }
      .concierge-input-container {
        padding: ${p.mobilePaddingY}px ${p.mobilePaddingX}px !important;
      }
      .concierge-input-container:not(:has(textarea[data-expanded])) {
        min-height: ${p.mobileMinHeight > 0 ? `${p.mobileMinHeight}px` : "auto"} !important;
      }
      .concierge-input-container:has(textarea[data-expanded]) {
        min-height: ${p.mobileMinHeight > 0 ? `${p.mobileMinHeight}px` : "auto"} !important;
        height: auto !important;
        /* Extra 4px on top/left when expanded for breathing room */
        padding: ${p.mobilePaddingY + 4}px ${p.mobilePaddingX}px ${p.mobilePaddingY}px ${p.mobilePaddingX + 4}px !important;
      }
      .concierge-prompt-input-icons {
        gap: ${p.mobileIconGap}px !important;
      }`;
  const mobileBlock = p.forceMobile ? mobileRules : `@media (max-width: 767px) {${mobileRules}
    }`;
  return `
    .concierge-prompt-input {
      --icon-size: auto;
      --submit-button-size: auto;
      --font-size-small: ${p.fontSize}px;
      --font-size-base: ${p.fontSize}px;
    }
    .concierge-prompt-input [data-slot="input-group"] {
      border: none !important;
      box-shadow: none !important;
      --tw-shadow: 0 0 #0000 !important;
      --tw-shadow-colored: 0 0 #0000 !important;
      background: transparent !important;
      padding: 0 !important;
      margin: 0 !important;
      min-height: 0 !important;
      height: auto !important;
      outline: none !important;
    }
    .concierge-prompt-input [data-slot="input-group"]:has([data-slot="input-group-control"]:focus-visible) {
      --tw-ring-color: transparent !important;
      --tw-ring-offset-width: 0 !important;
      --tw-ring-width: 0 !important;
      box-shadow: none !important;
    }
    .concierge-prompt-input [data-slot="input-group-control"]:focus-visible {
      outline: none !important;
      --tw-ring-color: transparent !important;
      box-shadow: none !important;
    }
    .concierge-prompt-input textarea,
    .concierge-prompt-input textarea:focus,
    .concierge-prompt-input textarea:focus-visible {
      border: none !important;
      outline: none !important;
      box-shadow: none !important;
      --tw-shadow: 0 0 #0000 !important;
      --tw-shadow-colored: 0 0 #0000 !important;
    }
    .concierge-prompt-input *:focus,
    .concierge-prompt-input *:focus-visible {
      outline: none !important;
      --tw-ring-color: transparent !important;
      --tw-ring-width: 0 !important;
      --tw-ring-offset-width: 0 !important;
    }
    .concierge-prompt-input:focus-within {
      outline: none !important;
    }
    .concierge-prompt-input textarea,
    .concierge-prompt-input textarea[data-slot="input-group-control"] {
      font-size: ${p.fontSize}px !important;
      font-weight: ${getFontWeightValue(p.fontWeight)} !important;
      font-family: ${p.fontFamilyCss} !important;
      color: ${p.textColor} !important;
      line-height: 1.5 !important;
    }
    .concierge-prompt-input textarea::placeholder {
      color: ${p.placeholderColor} !important;
    }

    ${mobileBlock}
  `;
}
export {
  buildPromptInputStyles,
  getFontWeightValue
};
//# sourceMappingURL=styles.js.map
